import { getLogger } from "../utils/logging";
import ApiService from "./ApiService";

// TODO: these should utilize a 'keepAlive' flag, or use window.sendBeacon...

const { log, warn } = getLogger('Log', { color: 'yellow', enabled: false });

class LogService {

    constructor() {
    }

    handleError(e, data?) {
        console.log('handleError', e, data);
        return true;
    }

    logError = (message, data, info, user) => {
        return new Promise((resolve, reject) => {
            log('error:', message, data, info, user)
            ApiService.post('/log/error', { message, data, info, user })
                .then(r => {
                    log('error response:', r)
                    return r.success ? resolve(r) : reject(r);
                })
                .catch(e => dd(e))
        });
    }

    logInfo = (message, data, info, user) => {
        return new Promise((resolve, reject) => {
            log('info:', message, data, info, user)
            ApiService.post('/log/info', { message, data, info, user })
                .then(r => {
                    log('info response:', r)
                    return r.success ? resolve(r) : reject(r);
                })
                .catch(e => reject(e))
        });
    }

    // shortcut to log debug info for a given user
    debug = (user, message, data?) => {
        return new Promise((resolve, reject) => {
            log('debug:', message, user, data)
            ApiService.post('/log/debug', { user, message, data })
                .then(r => {
                    return r.success ? resolve(r) : reject(r);
                })
                .catch(e => reject(e))
        });
    }

}

export default new LogService();